import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ProfileImage from "../../assets/images/profile/Profile.png";
import CalendarImage from "../../assets/images/profile/Calendar.png";
import PaperImage from "../../assets/images/profile/Paper.png";
import BookmarkImage from "../../assets/images/profile/Bookmark.png";
import LockImage from "../../assets/images/profile/Lock.png";
import LogoutImage from "../../assets/images/profile/Logout.png";
import { Config } from "../../Config";
import "./ProfileSideBar.scss";
import ChangeProfilePhoto from "../ChangeProfilePhoto/ChangeProfilePhoto";

const ProfileSideBar = (props) => {
  // const [fullName, setFullName] = useState("");
  // const [mobile, setMobile] = useState("");
  const [data, setData] = useState(null);
  // const [toggleButtons, setToggleButtons] = useState(false);
  // const [profileImage, setProfileImage] = useState("");
  // const [sendImageLoading, setSendImageLoading] = useState(false);
  // const [showImageSkeleton, setShowImageSkeleton] = useState(true);
  // const [image, setImage] = useState("");
  const [oilQuota, setOilQuota] = useState(null);
  const user = useSelector((state) => state.user);

  useEffect(() => {
    // setMobile(user[0]?.mobile);
    // setFullName(user[0]?.name);
    // setProfileImage(props.data);
    // if (props.data) {
    setData(props.data);
    setOilQuota(props.oilQuota);
    // setShowImageSkeleton(false);
    // }
  }, [props.data, props.oilQuota]);

  return (
    <div className="profileSideBar">
      <div className="sideBarItemsBox">
        <div className="profileBox">
          <ChangeProfilePhoto data={data} />
          <span className="profileTitle">{user[0]?.name ? user[0]?.name : "کاربر مهمان"}</span>
          <span className="profileNumber">{user[0]?.mobile ? user[0]?.mobile : "شماره ثبت نشده است!"}</span>
          {oilQuota && <span className="profileNumber">سهمیه روغن : {oilQuota} لیتر</span>}
        </div>
        <p className="sideBarTitle">پروفایل من</p>
        <div className="sideBarItems">
          <div className="sideBarItem needBefore active" onClick={(e) => props.action(e, "userInfo")}>
            <img src={PaperImage} alt="PaperImage" className="sideBarItemImage" />
            <span className="sideBarItemText">اطلاعات کاربری</span>
          </div>
          <hr />
          <div className="sideBarItem" onClick={(e) => props.action(e, "reservedhistory")}>
            <img src={CalendarImage} className="sideBarItemImage" />
            <span className="sideBarItemText">تاریخچه سفارش ها</span>
          </div>
          <hr />
          {/* <div className="sideBarItem">
            <img src={BookmarkImage} className="sideBarItemImage" />
            <span className="sideBarItemText">مورد علاقه ها</span>
          </div>
          <div className="sideBarItem">
            <img src={BookmarkImage} className="sideBarItemImage" />
            <span className="sideBarItemText">سفارش ها</span>
          </div>
          <div className="sideBarItem">
            <img src={BookmarkImage} className="sideBarItemImage" />
            <span className="sideBarItemText">بازدید های اخیر</span>
          </div>
          <div className="sideBarItem">
            <img src={BookmarkImage} className="sideBarItemImage" />
            <span className="sideBarItemText">پیام ها</span>
          </div> */}
          {/* <div className="sideBarItem" onClick={(e) => props.action(e, "changePassword")}>
            <img src={LockImage} alt="LockImage" className="sideBarItemImage" />
            <span className="sideBarItemText">تغییر کلمه عبور با پیامک</span>
          </div>
          <hr />
          <div className="sideBarItem" onClick={(e) => props.action(e, "changeBasePassword")}>
            <img src={LockImage} alt="LockImage" className="sideBarItemImage" />
            <span className="sideBarItemText">تغییر کلمه عبور ثابت</span>
          </div>
          <hr /> */}
          <div className="sideBarItem" onClick={(e) => props.action(e, "logout")}>
            <img src={LogoutImage} alt="LogoutImage" className="sideBarItemImage" />
            <span className="sideBarItemText">خروج از حساب</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ProfileSideBar);
